/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: grxNYctbMek6PL66cujx3u
// Component: 8XQkifTvj-Jd

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import LauncherComponentsTitle from "../../LauncherComponentsTitle"; // plasmic-import: hyfYYMUJ_ZCV/component
import { ApiRequest } from "@/common/fragment/components/api-request"; // plasmic-import: IpxudV5ARc89/codeComponent
import LauncherComponentsApp from "../../LauncherComponentsApp"; // plasmic-import: 25u6_6Q-fQwp/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: grxNYctbMek6PL66cujx3u/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: grxNYctbMek6PL66cujx3u/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: grxNYctbMek6PL66cujx3u/projectcss
import sty from "./PlasmicLauncherBlocksFeaturedApps.module.css"; // plasmic-import: 8XQkifTvj-Jd/css

import LauncherIconsLoaderIcon from "./icons/PlasmicIcon__LauncherIconsLoader"; // plasmic-import: 4lP5I8e4Rz71/icon

createPlasmicElementProxy;

export type PlasmicLauncherBlocksFeaturedApps__VariantMembers = {};
export type PlasmicLauncherBlocksFeaturedApps__VariantsArgs = {};
type VariantPropType = keyof PlasmicLauncherBlocksFeaturedApps__VariantsArgs;
export const PlasmicLauncherBlocksFeaturedApps__VariantProps =
  new Array<VariantPropType>();

export type PlasmicLauncherBlocksFeaturedApps__ArgsType = {
  openAppFrame?: (key: string) => void;
};
type ArgPropType = keyof PlasmicLauncherBlocksFeaturedApps__ArgsType;
export const PlasmicLauncherBlocksFeaturedApps__ArgProps =
  new Array<ArgPropType>("openAppFrame");

export type PlasmicLauncherBlocksFeaturedApps__OverridesType = {
  root?: Flex__<"div">;
  launcherComponentsTitle?: Flex__<typeof LauncherComponentsTitle>;
  apiRequest3?: Flex__<typeof ApiRequest>;
  apiRequest2?: Flex__<typeof ApiRequest>;
};

export interface DefaultLauncherBlocksFeaturedAppsProps {
  openAppFrame?: (key: string) => void;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch { }
  return undefined;
}

function PlasmicLauncherBlocksFeaturedApps__RenderFunc(props: {
  variants: PlasmicLauncherBlocksFeaturedApps__VariantsArgs;
  args: PlasmicLauncherBlocksFeaturedApps__ArgsType;
  overrides: PlasmicLauncherBlocksFeaturedApps__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const $globalActions = useGlobalActions?.();

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "apiRequest2.data",
        type: "private",
        variableType: "object",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined,

        refName: "apiRequest2"
      },
      {
        path: "apiRequest2.error",
        type: "private",
        variableType: "object",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined,

        refName: "apiRequest2"
      },
      {
        path: "apiRequest2.loading",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined,

        refName: "apiRequest2"
      },
      {
        path: "apiRequest3.data",
        type: "private",
        variableType: "object",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined,

        refName: "apiRequest3"
      },
      {
        path: "apiRequest3.error",
        type: "private",
        variableType: "object",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined,

        refName: "apiRequest3"
      },
      {
        path: "apiRequest3.loading",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined,

        refName: "apiRequest3"
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root
      )}
    >
      <LauncherComponentsTitle
        data-plasmic-name={"launcherComponentsTitle"}
        data-plasmic-override={overrides.launcherComponentsTitle}
        className={classNames("__wab_instance", sty.launcherComponentsTitle)}
        isNew={true}
        moreLink={"/_/apps"}
        moreTitle={``}
        subTitle={
          "\u062d\u0631\u0641\u0647\u200c\u0627\u06cc\u200c\u200c\u062a\u0631 \u062f\u0631 \u067e\u0630\u06cc\u0631\u0634\u06f2\u06f4"
        }
        title={
          "\u0627\u0645\u06a9\u0627\u0646\u0627\u062a \u06a9\u0627\u0631\u0628\u0631\u062f\u06cc"
        }
      />

      <div className={classNames(projectcss.all, sty.freeBox__kUujr)}>
        {(() => {
          try {
            return $ctx.auth.info.is_doctor;
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return false;
            }
            throw e;
          }
        })() ? (
          <div className={classNames(projectcss.all, sty.freeBox___3MSzO)}>
            <ApiRequest
              data-plasmic-name={"apiRequest3"}
              data-plasmic-override={overrides.apiRequest3}
              className={classNames("__wab_instance", sty.apiRequest3)}
              errorDisplay={null}
              loadingDisplay={
                <LauncherIconsLoaderIcon
                  className={classNames(projectcss.all, sty.svg__wSuKj)}
                  role={"img"}
                />
              }
              method={"GET"}
              onError={async (...eventArgs: any) => {
                generateStateOnChangeProp($state, [
                  "apiRequest3",
                  "error"
                ]).apply(null, eventArgs);
              }}
              onLoading={async (...eventArgs: any) => {
                generateStateOnChangeProp($state, [
                  "apiRequest3",
                  "loading"
                ]).apply(null, eventArgs);
              }}
              onSuccess={async (...eventArgs: any) => {
                generateStateOnChangeProp($state, [
                  "apiRequest3",
                  "data"
                ]).apply(null, eventArgs);
              }}
              params={(() => {
                try {
                  return Object.entries($ctx?.Growthbook?.features ?? {})
                    ?.filter?.(
                      ([key, value]) =>
                        key.startsWith("hamdast::apps::") && !!value
                    )
                    .reduce((prev, curr) => {
                      return {
                        ...prev,
                        [curr[0]?.replace("hamdast::apps::", "")]: curr[1]
                      };
                    }, {});
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return undefined;
                  }
                  throw e;
                }
              })()}
              ref={ref => {
                $refs["apiRequest3"] = ref;
              }}
              url={"https://hamdast.paziresh24.com/api/v1/list/featured"}
            >
              <div className={classNames(projectcss.all, sty.freeBox__ji35Z)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__l3Fm4
                  )}
                >
                  {
                    "\u0628\u0631\u06af\u0632\u06cc\u062f\u0647\u200c\u0647\u0627"
                  }
                </div>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__yX94U
                  )}
                >
                  {
                    "\u0628\u06cc\u0634\u062a\u0631\u06cc\u0646 \u0627\u0633\u062a\u0641\u0627\u062f\u0647 \u062f\u0631 \u0686\u0646\u062f \u0631\u0648\u0632 \u0627\u062e\u06cc\u0631"
                  }
                </div>
              </div>
              {(() => {
                try {
                  return $ctx.auth.info?.provider?.job_title === "doctor";
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return false;
                  }
                  throw e;
                }
              })()
                ? (_par => (!_par ? [] : Array.isArray(_par) ? _par : [_par]))(
                  (() => {
                    try {
                      return $state.apiRequest3.data;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return [];
                      }
                      throw e;
                    }
                  })()
                ).map((__plasmic_item_0, __plasmic_idx_0) => {
                  const currentItem = __plasmic_item_0;
                  const currentIndex = __plasmic_idx_0;
                  return (
                    <LauncherComponentsApp
                      _new={(() => {
                        try {
                          return currentItem.badges?.includes("NEW");
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return [];
                          }
                          throw e;
                        }
                      })()}
                      appkey={(() => {
                        try {
                          return currentItem.app_key;
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return undefined;
                          }
                          throw e;
                        }
                      })()}
                      avatar={(() => {
                        try {
                          return currentItem.icon;
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return undefined;
                          }
                          throw e;
                        }
                      })()}
                      className={classNames(
                        "__wab_instance",
                        sty.launcherComponentsApp__jRyz
                      )}
                      description={(() => {
                        try {
                          return currentItem.subtitle;
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return undefined;
                          }
                          throw e;
                        }
                      })()}
                      key={currentIndex}
                      link={(() => {
                        try {
                          return !!$props?.openAppFrame
                            ? undefined
                            : currentItem?.link;
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return undefined;
                          }
                          throw e;
                        }
                      })()}
                      name={(() => {
                        try {
                          return currentItem.title;
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return undefined;
                          }
                          throw e;
                        }
                      })()}
                      onEvent={async () => {
                        const $steps = {};

                        $steps["runOpenAppFrame"] = true
                          ? (() => {
                            const actionArgs = {
                              eventRef: $props["openAppFrame"],
                              args: [
                                (() => {
                                  try {
                                    return currentItem.app_key;
                                  } catch (e) {
                                    if (
                                      e instanceof TypeError ||
                                      e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                    ) {
                                      return undefined;
                                    }
                                    throw e;
                                  }
                                })()
                              ]
                            };
                            return (({ eventRef, args }) => {
                              return eventRef?.(...(args ?? []));
                            })?.apply(null, [actionArgs]);
                          })()
                          : undefined;
                        if (
                          $steps["runOpenAppFrame"] != null &&
                          typeof $steps["runOpenAppFrame"] === "object" &&
                          typeof $steps["runOpenAppFrame"].then === "function"
                        ) {
                          $steps["runOpenAppFrame"] =
                            await $steps["runOpenAppFrame"];
                        }

                        $steps["sendLog"] = true
                          ? (() => {
                            const actionArgs = {
                              args: [
                                (() => {
                                  try {
                                    return {
                                      evant_group: "launcher_statistics",
                                      event_type: "apps",
                                      user_id: $ctx.auth.info?.id,
                                      is_doctor: $ctx.auth.info?.is_doctor,
                                      meta_data: {
                                        name: currentItem.title,
                                        key: currentItem.app_key,
                                        link: currentItem.link
                                      }
                                    };
                                  } catch (e) {
                                    if (
                                      e instanceof TypeError ||
                                      e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                    ) {
                                      return undefined;
                                    }
                                    throw e;
                                  }
                                })()
                              ]
                            };
                            return $globalActions["Splunk.sendLog"]?.apply(
                              null,
                              [...actionArgs.args]
                            );
                          })()
                          : undefined;
                        if (
                          $steps["sendLog"] != null &&
                          typeof $steps["sendLog"] === "object" &&
                          typeof $steps["sendLog"].then === "function"
                        ) {
                          $steps["sendLog"] = await $steps["sendLog"];
                        }
                      }}
                      pagekey={"launcher"}
                      showUsers={(() => {
                        try {
                          return currentItem.functions?.includes?.("widget");
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return false;
                          }
                          throw e;
                        }
                      })()}
                      soon={(() => {
                        try {
                          return currentItem.badges?.includes("SOON");
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return [];
                          }
                          throw e;
                        }
                      })()}
                    />
                  );
                })
                : null}
            </ApiRequest>
          </div>
        ) : null}
        {(() => {
          try {
            return $ctx.auth.info.is_doctor;
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return false;
            }
            throw e;
          }
        })() ? (
          <div className={classNames(projectcss.all, sty.freeBox___8NIaY)}>
            <ApiRequest
              data-plasmic-name={"apiRequest2"}
              data-plasmic-override={overrides.apiRequest2}
              className={classNames("__wab_instance", sty.apiRequest2)}
              errorDisplay={null}
              loadingDisplay={
                <LauncherIconsLoaderIcon
                  className={classNames(projectcss.all, sty.svg__rRqBc)}
                  role={"img"}
                />
              }
              method={"GET"}
              onError={async (...eventArgs: any) => {
                generateStateOnChangeProp($state, [
                  "apiRequest2",
                  "error"
                ]).apply(null, eventArgs);
              }}
              onLoading={async (...eventArgs: any) => {
                generateStateOnChangeProp($state, [
                  "apiRequest2",
                  "loading"
                ]).apply(null, eventArgs);
              }}
              onSuccess={async (...eventArgs: any) => {
                generateStateOnChangeProp($state, [
                  "apiRequest2",
                  "data"
                ]).apply(null, eventArgs);
              }}
              params={(() => {
                try {
                  return Object.entries($ctx?.Growthbook?.features ?? {})
                    ?.filter?.(
                      ([key, value]) =>
                        key.startsWith("hamdast::apps::") && !!value
                    )
                    .reduce((prev, curr) => {
                      return {
                        ...prev,
                        [curr[0]?.replace("hamdast::apps::", "")]: curr[1]
                      };
                    }, {});
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return undefined;
                  }
                  throw e;
                }
              })()}
              ref={ref => {
                $refs["apiRequest2"] = ref;
              }}
              url={"https://hamdast.paziresh24.com/api/v1/list/new-releases"}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__n9Wqh
                )}
              >
                {
                  "\u062c\u062f\u06cc\u062f\u062a\u0631\u06cc\u0646\u200c\u0647\u0627"
                }
              </div>
              {(() => {
                try {
                  return $ctx.auth.info?.provider?.job_title === "doctor";
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return false;
                  }
                  throw e;
                }
              })()
                ? (_par => (!_par ? [] : Array.isArray(_par) ? _par : [_par]))(
                  (() => {
                    try {
                      return $state.apiRequest2.data;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return [];
                      }
                      throw e;
                    }
                  })()
                ).map((__plasmic_item_0, __plasmic_idx_0) => {
                  const currentItem = __plasmic_item_0;
                  const currentIndex = __plasmic_idx_0;
                  return (
                    <LauncherComponentsApp
                      _new={(() => {
                        try {
                          return currentItem.badges?.includes("NEW");
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return [];
                          }
                          throw e;
                        }
                      })()}
                      appkey={(() => {
                        try {
                          return currentItem.app_key;
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return undefined;
                          }
                          throw e;
                        }
                      })()}
                      avatar={(() => {
                        try {
                          return currentItem.icon;
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return undefined;
                          }
                          throw e;
                        }
                      })()}
                      className={classNames(
                        "__wab_instance",
                        sty.launcherComponentsApp__l6KBw
                      )}
                      description={(() => {
                        try {
                          return currentItem.subtitle;
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return undefined;
                          }
                          throw e;
                        }
                      })()}
                      key={currentIndex}
                      link={(() => {
                        try {
                          return !!$props?.openAppFrame
                            ? undefined
                            : currentItem?.link;
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return undefined;
                          }
                          throw e;
                        }
                      })()}
                      name={(() => {
                        try {
                          return currentItem.title;
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return undefined;
                          }
                          throw e;
                        }
                      })()}
                      onEvent={async () => {
                        const $steps = {};

                        $steps["runOpenAppFrame"] = true
                          ? (() => {
                            const actionArgs = {
                              eventRef: $props["openAppFrame"],
                              args: [
                                (() => {
                                  try {
                                    return currentItem.app_key;
                                  } catch (e) {
                                    if (
                                      e instanceof TypeError ||
                                      e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                    ) {
                                      return undefined;
                                    }
                                    throw e;
                                  }
                                })()
                              ]
                            };
                            return (({ eventRef, args }) => {
                              return eventRef?.(...(args ?? []));
                            })?.apply(null, [actionArgs]);
                          })()
                          : undefined;
                        if (
                          $steps["runOpenAppFrame"] != null &&
                          typeof $steps["runOpenAppFrame"] === "object" &&
                          typeof $steps["runOpenAppFrame"].then === "function"
                        ) {
                          $steps["runOpenAppFrame"] =
                            await $steps["runOpenAppFrame"];
                        }

                        $steps["sendLog"] = true
                          ? (() => {
                            const actionArgs = {
                              args: [
                                (() => {
                                  try {
                                    return {
                                      evant_group: "launcher_statistics",
                                      event_type: "apps",
                                      user_id: $ctx.auth.info?.id,
                                      is_doctor: $ctx.auth.info?.is_doctor,
                                      meta_data: {
                                        name: currentItem.title,
                                        key: currentItem.app_key,
                                        link: currentItem.link
                                      }
                                    };
                                  } catch (e) {
                                    if (
                                      e instanceof TypeError ||
                                      e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                    ) {
                                      return undefined;
                                    }
                                    throw e;
                                  }
                                })()
                              ]
                            };
                            return $globalActions["Splunk.sendLog"]?.apply(
                              null,
                              [...actionArgs.args]
                            );
                          })()
                          : undefined;
                        if (
                          $steps["sendLog"] != null &&
                          typeof $steps["sendLog"] === "object" &&
                          typeof $steps["sendLog"].then === "function"
                        ) {
                          $steps["sendLog"] = await $steps["sendLog"];
                        }
                      }}
                      pagekey={"launcher"}
                      showUsers={(() => {
                        try {
                          return currentItem.functions?.includes?.("widget");
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return false;
                          }
                          throw e;
                        }
                      })()}
                      soon={(() => {
                        try {
                          return currentItem.badges?.includes("SOON");
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return [];
                          }
                          throw e;
                        }
                      })()}
                    />
                  );
                })
                : null}
            </ApiRequest>
          </div>
        ) : null}
        {false ? (
          <LauncherComponentsApp
            avatar={
              "https://launcher.s3.ir-thr-at1.arvanstorage.ir/apps%2FSalamat%20Logo.svg?versionId="
            }
            className={classNames(
              "__wab_instance",
              sty.launcherComponentsApp__guxZx
            )}
            description={
              "\u0628\u0627 \u0647\u0648\u0634 \u0645\u0635\u0646\u0648\u0639\u06cc \u0628\u0647 \u0635\u0648\u0631\u062a \u0631\u0627\u06cc\u06af\u0627\u0646 \u0635\u062d\u0628\u062a \u06a9\u0646\u06cc\u062f."
            }
            link={"/_/roshan/salamat/?origin=launcher-apps"}
            name={
              "\u0645\u0634\u0627\u0648\u0631 \u0647\u0648\u0634 \u0645\u0635\u0646\u0648\u0639\u06cc \u0633\u0644\u0627\u0645\u062a"
            }
          />
        ) : null}
        {false ? (
          <LauncherComponentsApp
            avatar={
              "https://hamdast.s3.ir-thr-at1.arvanstorage.ir/apps%2Fliom%2Ficon.png"
            }
            className={classNames(
              "__wab_instance",
              sty.launcherComponentsApp__sAj3F
            )}
            description={
              "\u067e\u0631\u06cc\u0648\u062f \u0634\u0645\u0627 \u0646\u0627\u0645\u0646\u0638\u0645 \u0627\u0633\u062a\u061f \u0647\u0645\u06cc\u0646 \u0627\u0644\u0627\u0646\u060c \u06af\u0641\u062a\u06af\u0648 \u0631\u0627 \u0622\u063a\u0627\u0632 \u06a9\u0646\u06cc\u062f."
            }
            link={"/_/liom/irregularities/?origin=launcher"}
            name={
              "\u062a\u0634\u062e\u06cc\u0635 \u062f\u0647\u0646\u062f\u0647 \u0639\u0644\u062a \u067e\u0631\u06cc\u0648\u062f \u0646\u0627\u0645\u0646\u0638\u0645"
            }
          />
        ) : null}
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "launcherComponentsTitle", "apiRequest3", "apiRequest2"],
  launcherComponentsTitle: ["launcherComponentsTitle"],
  apiRequest3: ["apiRequest3"],
  apiRequest2: ["apiRequest2"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  launcherComponentsTitle: typeof LauncherComponentsTitle;
  apiRequest3: typeof ApiRequest;
  apiRequest2: typeof ApiRequest;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicLauncherBlocksFeaturedApps__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicLauncherBlocksFeaturedApps__VariantsArgs;
    args?: PlasmicLauncherBlocksFeaturedApps__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
  // Specify variants directly as props
  Omit<PlasmicLauncherBlocksFeaturedApps__VariantsArgs, ReservedPropsType> &
  // Specify args directly as props
  Omit<PlasmicLauncherBlocksFeaturedApps__ArgsType, ReservedPropsType> &
  // Specify overrides for each element directly as props
  Omit<
    NodeOverridesType<T>,
    ReservedPropsType | VariantPropType | ArgPropType
  > &
  // Specify props for the root element
  Omit<
    Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
    ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
  >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicLauncherBlocksFeaturedApps__ArgProps,
          internalVariantPropNames:
            PlasmicLauncherBlocksFeaturedApps__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicLauncherBlocksFeaturedApps__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicLauncherBlocksFeaturedApps";
  } else {
    func.displayName = `PlasmicLauncherBlocksFeaturedApps.${nodeName}`;
  }
  return func;
}

export const PlasmicLauncherBlocksFeaturedApps = Object.assign(
  // Top-level PlasmicLauncherBlocksFeaturedApps renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    launcherComponentsTitle: makeNodeComponent("launcherComponentsTitle"),
    apiRequest3: makeNodeComponent("apiRequest3"),
    apiRequest2: makeNodeComponent("apiRequest2"),

    // Metadata about props expected for PlasmicLauncherBlocksFeaturedApps
    internalVariantProps: PlasmicLauncherBlocksFeaturedApps__VariantProps,
    internalArgProps: PlasmicLauncherBlocksFeaturedApps__ArgProps
  }
);

export default PlasmicLauncherBlocksFeaturedApps;
/* prettier-ignore-end */
